const VISIBLE_FACETS_COUNT = 5;
const VISIBLE_REFINEMENTS_PER_FACET_COUNT = 5;
const FACET_CONTENT_MAX_HEIGHT = 32 * 10 + 9 * 4 + 2 * 16;
const ID_REGEXP = /^\d+/;
const LOCALE_REGEXP = /\/[a-z]{2}(?:-[a-z]{2})?(?=(?:\/|$))/gi;
const PRODUCT_RANGE_SEGMENT = 'product-range/';
const RANGE_ENDPOINT = 'product/';

export { FACET_CONTENT_MAX_HEIGHT as F, ID_REGEXP as I, LOCALE_REGEXP as L, PRODUCT_RANGE_SEGMENT as P, RANGE_ENDPOINT as R, VISIBLE_FACETS_COUNT as V, VISIBLE_REFINEMENTS_PER_FACET_COUNT as a };
